import { createRouter, parseSearchWith, stringifySearchWith } from '@tanstack/react-router';
import { rootRoute } from './routes/__root';
import { indexRoute } from '@/routes';
import { onboardingRoute } from './routes/onboarding';
import { quizRoute } from './routes/quiz';
import { checkoutRoute } from './routes/checkout';
import { additionalOffersRoute } from './routes/additional-offers';
import { successRoute } from './routes/success';
import { redirectRoute } from './routes/redirect';

const routeTree = rootRoute.addChildren([
  indexRoute,
  onboardingRoute,
  quizRoute,
  checkoutRoute,
  additionalOffersRoute,
  successRoute,
  redirectRoute,
]);

export const router = createRouter({
  routeTree,
  // Keep query values as strings. The default JSON parser turns Meta campaign
  // ids (e.g. 120248688072220752) into unsafe numbers and rewrites the URL.
  parseSearch: parseSearchWith((value) => value),
  stringifySearch: stringifySearchWith(String),
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}
